import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import {
  FreeBetsWrapper,
  UnderMaintenanceWr,
  SlowConnectionWr,
  FreeBetMaxPayoutPopUp,
  MaxWinPopup,
  loadingStore,
} from '@pascal/pascal-core';

import { GameWrapper } from '../../containers/gameWrapper';
import { gameMainDrawer } from '../drawers/gameDrawer/gameMainDrawer';

const WebGameMain = observer(() => {
  const ref = useRef();

  useEffect(() => {
    if (!ref.current) return;
    gameMainDrawer.execute(ref.current).then(() => {
      loadingStore.updateLoading({ isPixiLoaded: true });
    });
  }, [ref.current]);

  return (
    <>
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <GameHolder>
        <GameBackside refProp={ref} />
        <div className='new-fishing-game-container'>
          <FreeBetsWrapper />
          <MaxWinPopup />
          <FreeBetMaxPayoutPopUp />
          <GameWrapper />
        </div>
      </GameHolder>
    </>
  );
});

export default WebGameMain;
